import React, { forwardRef, useImperativeHandle, ReactElement } from 'react';
import { Dialog, DialogContent, DialogActions, Box } from '@mui/material';
import TypographyLevel from 'shared/components/Typography';
import { ButtonComp } from 'shared/components/AppComponents';
import {
    DialogFormBoxButton,
    DialogFormBoxContent,
    DialogFormBoxJustify,
    DialogFormBoxStepContent,
} from 'assets/styles/modules/upload-documents/upload-packet/DialogForm';

/**
 * Represents the DialogFormUpload component.
 *
 * @param {DialogFormUploadProps} props - The component props.
 * @param {React.Ref} ref - The ref to expose certain functions or values.
 * @returns {ReactElement} - The rendered component.
 */
const DialogFormUpload = forwardRef(
    (
        {
            state,
            setOpenDialog,
            confirmation,
            valueClient,
        }: DialogFormUploadProps,
        ref
    ): ReactElement => {
        // Actions
        const actionPositive = (): void => {
            confirmation(false, true);
        };
        const actionNegative = (): void => {
            setOpenDialog(false);
        };

        // Pass Actions
        useImperativeHandle(ref, () => ({
            setOpenDialog,
        }));

        return (
            <Box>
                <Dialog
                    open={state.openDialog}
                    onClose={() => setOpenDialog(false)}
                    maxWidth="md"
                    sx={{
                        '& .MuiDialog-paper': {
                            width: '39rem',
                        },
                    }}
                >
                    <DialogContent
                        dividers
                        className="DialogForm-DialogContent"
                    >
                        <Box className="DialogForm-ContentBox">
                            <Box sx={DialogFormBoxContent}>
                                <TypographyLevel variant="two">
                                    <Box>
                                        Please confirm if the checklist and
                                    </Box>
                                    <Box>the reference number are correct.</Box>
                                </TypographyLevel>
                            </Box>

                            <Box sx={DialogFormBoxStepContent}>
                                <TypographyLevel variant="four">
                                    <Box sx={DialogFormBoxJustify}>
                                        Checklist: &nbsp;
                                        <Box className="DialogForm-BoxClientName">
                                            {valueClient.name}
                                        </Box>
                                    </Box>
                                    <Box sx={DialogFormBoxJustify}>
                                        Reference Number: &nbsp;
                                        <Box
                                            className="DialogForm-BoxClientName"
                                            data-testid="bin-number-text"
                                        >
                                            {state.valueBin}
                                        </Box>
                                    </Box>
                                </TypographyLevel>
                            </Box>
                        </Box>
                    </DialogContent>

                    <DialogActions className="DialogFile-DialogAction">
                        <Box sx={DialogFormBoxButton}>
                            <ButtonComp
                                width="16rem"
                                onClick={() => actionNegative()}
                                type="neutral"
                            >
                                Go back & Edit
                            </ButtonComp>
                            <ButtonComp
                                width="16rem"
                                onClick={() => actionPositive()}
                                type="primary"
                            >
                                Confirm & Proceed
                            </ButtonComp>
                        </Box>
                    </DialogActions>
                </Dialog>
            </Box>
        );
    }
);

export default DialogFormUpload;
